import React from 'react';
import { compose, withProps } from 'recompose';
import { useDeviceSelector } from 'js/store/hooks';
import { ClickableCard } from '../../common/Card';
import withCardInfo from './withCardInfo';
import { DiscoveryItemWidgetMedia } from '../../common/DiscoveryItemWidgetMedia/DiscoveryItemWidgetMedia';
import style from './index.scss';
import { pick } from 'ramda';

export const RaceListSliderCard = ({
    className = '',
    image,
    status,
    fakeState,
    leaderboardEndTime: endTime,
    leaderboardStartTime: startTime,
    myeventRegistrationStartTime,
    myeventRegistrationEndTime,
    racesPositioning,
    rank,
    registrationStatus,
    displayCountdown,
    onClick,
    isParcel,
    joined,
    missions
}) => {
    return (
        <ClickableCard className={`${style.card} ${style[racesPositioning] || ''} ${className}`} onClick={onClick} >
            <DiscoveryItemWidgetMedia {...{ status,
                endTime,
                startTime,
                myeventRegistrationStartTime,
                myeventRegistrationEndTime,
                image,
                registrationStatus,
                displayCountdown,
                fakeState,
                rank,
                isParcel,
                missions,
                joined }} displayStatusAndWidgetIcon={false}/>
        </ClickableCard>
    );
};

export const withCardType = withProps(
    () => {
        const { isMobile, isDesktop, isLandscape, isTablet, isPortrait } = useDeviceSelector(pick([
            'isMobile', 'isDesktop', 'isLandscape', 'isTablet', 'isPortrait'
        ]));
        return {
            isWideCard: isDesktop || isTablet && isLandscape,
            isMiddleCard: isTablet && isPortrait || isMobile && isLandscape,
            isNarrowCard: isMobile && isPortrait
        };
    }
);

export const withCardImage = withProps(
    ({ isMiddleCard, isNarrowCard, bannerUrl, mediumSizeImage, smallSizeImage }) => ({
        image: isNarrowCard
            ? smallSizeImage || mediumSizeImage || bannerUrl
            : isMiddleCard
                ? mediumSizeImage || bannerUrl
                : bannerUrl
    })
);

export default compose(
    withCardType,
    withCardInfo,
    withCardImage
)(RaceListSliderCard);
